import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

import { MainLayout, renderLayout } from './uiComponents/mainLayout';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { Overlay } from 'src/domains/layouts/webview/components/overlay/Overlay';
import { AppWrapper } from './ui.style';
import { NoConnection } from 'src/domains/layouts/layouts/utilityPages/errorPage/NoConnection';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { BlockingNotifications } from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications';
import { StaticPageContent } from 'src/domains/players/webview/components/Account/Notifications/StaticPageContent';
import { BlockingNotificationType } from 'src_server/trpc/types/accountModel/accountResponse';
import { SdkCustomer } from 'src/domains/layouts/state/customer';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { BlockingNotificationsState } from 'src/domains/players/state/BlockingNotification.state';
import { Overlay as OverlayState } from '../state/overlay/Overlay';
import { BannersBoxState } from '../state/bannersBoxState/BannersBoxState';
import { NetworkConnectionState } from '../state/networkConnectionState/NetworkConnectionState';
import { GamblingSafetyBar } from './uiComponents/GamblingSafetyBar';
import { BannersMain } from './uiComponents/BannersMain';
import { AppGlobalLayers } from './uiComponents/AppGlobalLayers';

export const AppInner = observer('AppInner', () => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const router = StarRouter.get(common);
    const env = EnvironmentState.get(common);

    const blockingNotificationsState = BlockingNotificationsState.get(common);
    const isMobileApp = env.isMobileApp();

    const getMainId = (): string | undefined => {
        return 'app-wrapper';
    };

    const sdkCustomer = SdkCustomer.get(common);
    const { userId } = sdkCustomer.session;

    const overlayOnClick = (): void => {
        //Handler for overlay - to improve in the future
        // console.info('overlay on click');
        OverlayState.get(common).toggleMenu();
    };

    const currentView = router.currentView;
    const isLayoutHasAside = renderLayout() !== null;

    const { streamBoxHeight, isStreamFloating } = StreamingState.get(common);
    const { boxHeight: bannersHeight } = BannersBoxState.get(common);
    const { shouldOverlayOpen, overlayLevel: overlayIndex } = OverlayState.get(common);

    const hasIdMission = config.idMission;

    const { showOfflineMessage } = NetworkConnectionState.get(common);

    const blockingNotificationType = blockingNotificationsState.getBlockingNotificationType;

    const isKycRestrictionWithIdMission =
        hasIdMission && blockingNotificationType === BlockingNotificationType.KYC_DEPOSIT_RESTRICTION;

    if (blockingNotificationType !== null && isKycRestrictionWithIdMission === false) {
        return <BlockingNotifications blockingNotificationType={blockingNotificationType} />;
    }

    if (currentView?.name === 'homepage' && currentView.staticPage !== null) {
        if (currentView.staticPage === 'terms-and-conditions' || currentView.staticPage === 'privacy-policy') {
            return <StaticPageContent id={currentView.staticPage} />;
        }
    }

    return (
        <AppWrapper
            data-track={userId}
            id={getMainId()}
            bannersHeight={bannersHeight}
            streamHeight={streamBoxHeight}
            isStreamFloating={isStreamFloating}
            isLayoutHasAside={isLayoutHasAside}
        >
            {showOfflineMessage && isMobileApp === false ? <NoConnection /> : null}
            <GamblingSafetyBar />
            <BannersMain />
            <MainLayout />
            <AppGlobalLayers />
            <Overlay
                isVisible={shouldOverlayOpen}
                onClick={overlayOnClick}
                zIndex={overlayIndex}
            />
        </AppWrapper>
    );
});
